import { ScrollTrigger, scrollSmootherInstance, gsap } from "../globals/gsap";
import Header from "../globals/header";
import pageTransition from "../globals/pageTransition";

class DefaultTransition {
  beforeOnce(data) {
    // console.log('beforeOnce');
    window.scrollTo(0, 0);
  }

  beforeLeave(data) {
    // scrollSmootherInstance.paused(true);
    // const done = this.async();
    // pageTransition.animateIn(() => {
    //   console.log('callback');
    //   scrollSmootherInstance.paused(false);
    //   done();
    // });
  }

  leave(data) {
    scrollSmootherInstance.paused(true);
    // return new Promise((resolve) => {
    //   const $inViewElements = $(data.current.container).find('.in-view');
    //   $inViewElements.removeClass('in-view');
    //   // listen to transition end event
    //   setTimeout(() => {
    //     resolve();
    //   }, 1200);
    // });
  }

  enter(data) {
    scrollSmootherInstance.paused(false);
  }

  beforeEnter(data) {
    // console.log('scrollTop');
    scrollSmootherInstance.scrollTop(0);
    Header.closeFlyout(false);
    // pageTransition.animateOut();
  }

  after(data) {
    ScrollTrigger.refresh();
  }
}

export default new DefaultTransition();
